export default "static/media/ccc.d5f470a.svg"